var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteRule(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7071 6.54292C18.0976 6.93345 18.0976 7.56661 17.7071 7.95714L7.70714 17.9571C7.31661 18.3476 6.68345 18.3476 6.29292 17.9571C5.9024 17.5666 5.9024 16.9334 6.29292 16.5429L16.2929 6.54292C16.6834 6.1524 17.3166 6.1524 17.7071 6.54292Z",
    fill: "#C6CED8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7071 17.957C17.3166 18.3475 16.6834 18.3475 16.2929 17.957L6.29289 7.95701C5.90237 7.56649 5.90237 6.93332 6.2929 6.5428C6.68342 6.15228 7.31658 6.15228 7.70711 6.5428L17.7071 16.5428C18.0976 16.9333 18.0976 17.5665 17.7071 17.957Z",
    fill: "#C6CED8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRule);
export default __webpack_public_path__ + "static/media/delete-rule.1bfd1ecc7a710b23e690fab019b78b80.svg";
export { ForwardRef as ReactComponent };